// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Yl_75zMhUmcYYeH1JOPw {
  width: 300px;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 10px 38px -10px rgba(22, 23, 24, 0.35), 0 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation: jDDKsJmzp76RTbOgHZOL 0.2s ease-out;
  z-index: 10000;
}
@keyframes jDDKsJmzp76RTbOgHZOL {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.rIi8EDjxBRhyMbcufThA {
  fill: white;
}

.fqWJQqNSXq6za_pWX11i {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.E4niAjW4riM4TLpvyaWw {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.UAAEO7d9hOBvqMnNdwGT {
  flex: 1;
}

.xMyDOA9XQ39Q3zm1ICWA {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 6px 0;
}

.iR1H_KyWLlmCtHny_swn {
  display: flex;
  align-items: center;
  gap: 8px;
}

.WDLtIFumdwtD2yXDcoQC {
  font-size: 12px;
  color: #666;
}

.rdAg9Lda_pWRqr3PgoGB {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
}

.Hp9XGlHS18Ag7zFwiRnV {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 12px 0;
}

.x9JsfKrHWlBeA57SyDOu {
  margin: 16px 0;
}

.SYSMrwxBuYwFVCllOp2N {
  padding: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
}

.zKhVdG3UQ3JRDrHAjiag {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.UePMjyGGaAV1_VETskU7 {
  font-size: 12px;
  color: #1a1a1a;
  font-weight: 600;
}

.dn2HBk4BXiDu_Ihpcf9H {
  font-size: 13px;
  color: #991b1b;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.ZDsuGcAY3cuJy3OglZtR {
  width: 100%;
  padding: 8px 16px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.ZDsuGcAY3cuJy3OglZtR:hover {
  background: #dc2626;
}

.hgsElvvSpiK4_HG726zg {
  padding: 10px;
  background: #fffbeb;
  border: 1px solid #fde047;
  border-radius: 8px;
}
.hgsElvvSpiK4_HG726zg .dn2HBk4BXiDu_Ihpcf9H {
  color: #92400e;
  margin-bottom: 6px;
}

.JgqOZyASh5qFut8qWQMi {
  font-size: 13px;
  color: #dc2626;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}
.JgqOZyASh5qFut8qWQMi:hover {
  text-decoration: underline;
}

.DmUzgeaEaiOvru2DHxvg {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e5e5e5;
}

.EpxvEFpzceDZzDNxFzpW {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nnBIaFN7CHZ4pOdLhC2X {
  margin: 0;
  padding: 0;
  list-style: none;
}
.nnBIaFN7CHZ4pOdLhC2X li {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  padding-left: 16px;
  position: relative;
}
.nnBIaFN7CHZ4pOdLhC2X li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ccc;
}
.nnBIaFN7CHZ4pOdLhC2X li:last-child {
  margin-bottom: 0;
}

@media (prefers-color-scheme: dark) {
  .Yl_75zMhUmcYYeH1JOPw {
    background: #1a1a1a;
    box-shadow: 0 10px 38px -10px rgba(0, 0, 0, 0.5), 0 10px 20px -15px rgba(0, 0, 0, 0.3);
  }
  .rIi8EDjxBRhyMbcufThA {
    fill: #1a1a1a;
  }
  ._j3Fi1U4opx7trnFLvQ6,
  .xMyDOA9XQ39Q3zm1ICWA,
  .rdAg9Lda_pWRqr3PgoGB {
    color: #f0f0f0;
  }
  .v5Xy_FnYeRubM5K0rI_a,
  .WDLtIFumdwtD2yXDcoQC,
  .Hp9XGlHS18Ag7zFwiRnV {
    color: #999;
  }
  .JXVyL0ciIxUfQKGrTVtM {
    background: #333;
  }
  .SYSMrwxBuYwFVCllOp2N {
    background: #2a1515;
    border-color: #7f1d1d;
  }
  .hgsElvvSpiK4_HG726zg {
    background: #2a2515;
    border-color: #713f12;
  }
  .zKhVdG3UQ3JRDrHAjiag {
    color: #999;
  }
  .UePMjyGGaAV1_VETskU7 {
    color: #f0f0f0;
  }
  .DmUzgeaEaiOvru2DHxvg {
    border-top-color: #333;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/auth/components/TokenDetailsCard.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,6FACE;EAEF,6CAAA;EACA,cAAA;AAFF;AAIE;EACE;IACE,UAAA;IACA,0BAAA;EAFJ;EAIE;IACE,UAAA;IACA,wBAAA;EAFJ;AACF;;AAMA;EACE,WAAA;AAHF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAPF;;AAUA;EACE,OAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAPF;;AAUA;EACE,eAAA;EACA,WAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAPF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AARF;;AAWA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AARF;;AAWA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AARF;;AAWA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AARF;AAUE;EACE,mBAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AATF;AAWE;EACE,cAAA;EACA,kBAAA;AATJ;;AAaA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAVF;AAYE;EACE,0BAAA;AAVJ;;AAeA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAZF;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAZF;AAcE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAZJ;AAcI;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;AAZN;AAeI;EACE,gBAAA;AAbN;;AAmBA;EACE;IACE,mBAAA;IACA,sFACE;EAjBJ;EAqBA;IACE,aAAA;EAnBF;EAsBA;;;IAGE,cAAA;EApBF;EAuBA;;;IAGE,WAAA;EArBF;EAwBA;IACE,gBAAA;EAtBF;EAyBA;IACE,mBAAA;IACA,qBAAA;EAvBF;EA0BA;IACE,mBAAA;IACA,qBAAA;EAxBF;EA2BA;IACE,WAAA;EAzBF;EA4BA;IACE,cAAA;EA1BF;EA6BA;IACE,sBAAA;EA3BF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hoverCardContent": `Yl_75zMhUmcYYeH1JOPw`,
	"slideUpAndFade": `jDDKsJmzp76RTbOgHZOL`,
	"hoverCardArrow": `rIi8EDjxBRhyMbcufThA`,
	"tokenHeader": `fqWJQqNSXq6za_pWX11i`,
	"tokenIconLarge": `E4niAjW4riM4TLpvyaWw`,
	"tokenInfo": `UAAEO7d9hOBvqMnNdwGT`,
	"tokenTitle": `xMyDOA9XQ39Q3zm1ICWA`,
	"tokenBalance": `iR1H_KyWLlmCtHny_swn`,
	"balanceLabel": `WDLtIFumdwtD2yXDcoQC`,
	"balanceCount": `rdAg9Lda_pWRqr3PgoGB`,
	"tokenDescription": `Hp9XGlHS18Ag7zFwiRnV`,
	"actionsSection": `x9JsfKrHWlBeA57SyDOu`,
	"outOfTokens": `SYSMrwxBuYwFVCllOp2N`,
	"optionLabel": `zKhVdG3UQ3JRDrHAjiag`,
	"optionValue": `UePMjyGGaAV1_VETskU7`,
	"warningText": `dn2HBk4BXiDu_Ihpcf9H`,
	"purchaseButton": `ZDsuGcAY3cuJy3OglZtR`,
	"lowTokenWarning": `hgsElvvSpiK4_HG726zg`,
	"refillLink": `JgqOZyASh5qFut8qWQMi`,
	"usageTips": `DmUzgeaEaiOvru2DHxvg`,
	"tipsTitle": `EpxvEFpzceDZzDNxFzpW`,
	"tipsList": `nnBIaFN7CHZ4pOdLhC2X`,
	"userName": `_j3Fi1U4opx7trnFLvQ6`,
	"userEmail": `v5Xy_FnYeRubM5K0rI_a`,
	"divider": `JXVyL0ciIxUfQKGrTVtM`
};
export default ___CSS_LOADER_EXPORT___;
